import React, { FC } from 'react';
import { Box, Stack } from '@mui/material';
import { Button } from 'reactstrap';

import SignUpStepper from 'src/components/stepper';
import { Layout } from 'src/components/layout-wrapper/Layout';
import DiamondIcon from 'src/assets/icons/diamond.svg';
import history from 'src/lib/history';
import { useViewport } from 'src/lib/utils';
import { SubscriptionPageProps } from '../SubscriptionPage';
import { useAppSelector } from 'src/store/hooks';
import colors from 'src/styles/equalution/colors';
import { ChallengePlanSelection } from '../components/challenge-package/ChallengePlanSelection';
import { ChallengePlan } from 'src/pages/types';

type ChallengeBundleFlowProps = SubscriptionPageProps & {
  challengePlans: ChallengePlan[];
};

const ChallengeBundleFlow: FC<ChallengeBundleFlowProps> = ({
  onCheckoutClick,
  showTwoStepProcess,
  challengePlans,
  selectedPlanId,
}) => {
  const { challengePackageSelectedPlan } = useAppSelector(
    state => state.signUp
  );
  const { isMobile } = useViewport();

  return (
    <Layout module="login">
      <Stack
        alignItems="center"
        sx={{
          padding: { xs: '1.5rem 1rem 4rem', md: '2rem 1.5rem 4rem' },
          marginX: 'auto',
          width: '100%',
          maxWidth: '1248px',
          boxSizing: 'border-box',
          overflowX: 'hidden',
        }}>
        <Stack
          mb={isMobile ? '24px' : '48px'}
          alignItems="center"
          width="100%"
          sx={{ boxSizing: 'border-box' }}>
          <Box width={showTwoStepProcess ? 70 : 100}>
            <SignUpStepper
              activeStep={1}
              steps={showTwoStepProcess ? ['1', '2'] : ['1', '2', '3']}
            />
          </Box>
          <Box width="100%" mt="24px">
            <Box
              sx={{
                fontSize: isMobile ? '22px' : '30px',
                fontWeight: 700,
                textAlign: 'center',
                lineHeight: 1.1,
                paddingX: { xs: '8px', md: 0 },
                wordBreak: 'break-word',
              }}>
              Choose your Challenge Bundle
            </Box>
          </Box>
        </Stack>

        <ChallengePlanSelection plans={challengePlans} variant="bundle" />

        <Box height="32px" />

        <Button
          style={{ width: isMobile ? '100%' : 420, maxWidth: '100%' }}
          size="md"
          disabled={!selectedPlanId || !challengePackageSelectedPlan?.id}
          onClick={onCheckoutClick}>
          Continue to checkout
        </Button>

        {!showTwoStepProcess ? (
          <>
            <Box height="20px" />
            <Button
              outlined
              onClick={() => history.push('/login-account')}
              size="md"
              style={{
                width: isMobile ? '100%' : 420,
                maxWidth: '100%',
                backgroundColor: 'transparent',
                paddingInline: '8px',
                display: 'flex',
                justifyContent: 'center',
                flexShrink: 0,
              }}>
              <Stack direction="row" alignItems="center" flexWrap="nowrap">
                <Box component="img" src={DiamondIcon} alt="diamond" />
                <Box
                  ml="12px"
                  color={colors.SALAD}
                  fontSize="16px"
                  fontWeight={600}
                  sx={{ whiteSpace: 'nowrap' }}>
                  Log in for Member Pricing
                </Box>
              </Stack>
            </Button>
          </>
        ) : null}
      </Stack>
    </Layout>
  );
};

export default ChallengeBundleFlow;
